import { Component, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UploadViewerComponent } from 'src/app/components/upload-viewer/upload-viewer.component';


@Component({
  selector: 'app-plantilla-demo-fclight',
  templateUrl: './plantilla-demo-fclight.component.html',
  styleUrls: ['./plantilla-demo-fclight.component.scss']
})
export class PlantillaDemoFCLightComponent {
  readonly panelOpenState = signal(true);

  pdfUrl: SafeResourceUrl | null = null;

  deudoresDisplayedColumns: string[] = ['n', 'nombre', 'rut', 'montoFacturas', 'montoFacturasAFinanciar', 'nInformesCom', 'montoInformesCom']
  deudoresLabels: string[] = ['N', 'Nombre', 'Rut', 'Monto Facturas', 'Monto Facturas a Financiar', 'N Informes Comerciales', 'Monto Informes Comerciales'];
  deudoresDataSource: any[] = [ 
    {
      n: '123',
      nombre: 'deudor 1',
      rut: '1-9',
      montoFacturas: '10.000',
      montoFacturasAFinanciar: '15.000',
      nInformesCom: '10',
      montoInformesCom: '8.000'
    } 
  ]

  factoringDisplayedColumns: string[] = ['rut', 'nombre', 'monto3', 'monto6', 'monto12'];
  factoringLabels: string[] = ['Rut', 'Nombre', 'Monto Cesiones 3 meses', 'Monto Cesiones 6 meses', 'Monto Cesiones 12 meses']
  factoringDataSource: any[] = [ 
    {
      rut: '1-9',
      nombre: 'Factoring 1',
      monto3: '10.000',
      monto6: '15.000',
      monto12: '30.000'
    } 
  ]

  UltimoBDisplayedColumns: string[] = ['patrimonio', 'leverage', 'utilidad'];
  UltimoBLabels: string[] = ['Patrimonio (M$)', 'Leverage', 'Utilidad (M$)']
  UltimoBDataSource: any[] = [ 
    {
      patrimonio: 'dic-25',
      leverage: 'dic-25',
      utilidad: 'dic-25',
    } 
  ]

  VPMisplayedColumns: string[] = ['eneDic', 'eneFecha'];
  VPMLabels: string[] = ['Ene-Dic', 'Ene a la fecha']
  VPMDataSource: any[] = [ 
    {
      eneDic: '2024',
      eneFecha: '2025',
    } 
  ]

  MPisplayedColumns: string[] = ['n', 'montoM'];
  MPLabels: string[] = ['', '']
  MPDataSource: any[] = [ 
    {
      n: 'N',
      montoM: 'MontoM',
    } 
  ]

  FinAnioisplayedColumns: string[] = ['meses', 'ventas', 'compras', 'diferencia', 'fecha', 'tipoDeclaracion', 'posterga'];
  FinAnioLabels: string[] = ['Meses', 'Ventas', 'Compras', 'Diferencia', 'Fecha', 'Tipo Declaración', 'Posterga']
  FinAnioDataSource: any[] = [ 
    { meses: 'enero', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'febrero', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'marzo', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'abril', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'mayo', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'junio', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'julio', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'agosto', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'septiembre', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'octubre', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'noviembre', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' },
    { meses: 'diciembre', ventas: '', compras: '', diferencia: '', fecha: '', tipoDeclaracion: '', posterga: '' }
  ];


  constructor(
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {}

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
  
    if (input.files && input.files.length > 0) {
      const file = input.files[0]; // Get the selected file
      this.convertToBlob(file);
    }
  }
  
  convertToBlob(file: File) {
    const reader = new FileReader();
  
    reader.onload = (event: ProgressEvent<FileReader>) => {
      if (event.target && event.target.result) {
        const blob = new Blob([event.target.result], { type: file.type });
  
        // this.pdfData = blob;
        const url = URL.createObjectURL(blob);
        this.pdfUrl =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
        // window.open(url);
        console.log('PDF Blob:', blob);
        // You can now use the Blob, e.g., upload it, preview it, or send it to an API
      }
    };
  
    reader.readAsArrayBuffer(file); // Read the file as an ArrayBuffer
  }

  seePDF() {
    const dialogRef = this.dialog.open(UploadViewerComponent, {
      data: { pdfUrl: this.pdfUrl },
      width: '80%'
    });
  }
}
